import ColumnRef from './ColumnRef';

/**
 * Represents a change (add/remove) of a join
 */
export default class JoinDelta {
  constructor(left, right, add) {
    this._left = left; // ColumnRef
    this._right = right; // ColumnRef
    this._add = add; // true if add / false if remove
  }

  static buildFromServer(serverObj) {
    return new JoinDelta(
      ColumnRef.buildFromServer(serverObj._left),
      ColumnRef.buildFromServer(serverObj._right),
      serverObj._add,
    );
  }

  left() {
    return this._left;
  }

  right() {
    return this._right;
  }

  isAdd() {
    return this._add;
  }

  isRemove() {
    return this._remove;
  }

  swap() {
    return new JoinDelta(this.right(), this.left(), this.isAdd());
  }

  negate() {
    return new JoinDelta(this.left(), this.right(), !this.isAdd());
  }

  equals(d) {
    if (!d) {
      return false;
    }
    if (!this.left().equals(d.left())) {
      return false;
    }
    if (!this.right().equals(d.right())) {
      return false;
    }
    if (this.isAdd() !== d.isAdd()) {
      return false;
    }
    return true;
  }
}
